import React, { Suspense } from 'react';

const DelayedSmartPageSignupStep =
  React.lazy(() => import(/* webpackChunkName: "smart-page-signup-step.async" */ './smart-page-signup-step')
    .then(({ SmartPageSignupStepWithI18n }) => ({ default: SmartPageSignupStepWithI18n })));

export const DelayedSmartPageSignupStepWithI18n = () => (
  <Suspense fallback={null}>
    <DelayedSmartPageSignupStep />
  </Suspense>
);
